import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Flex, Spin } from 'antd';
import { fetchRpmCPDailyMedicationList, setSelectedRpmPatient } from '../../../../../../../Redux/actions/rpmActions';
import CarePlanDailyMedicationTable from './carePlanDailyMedicationTable';

function Index() {
    const [currentPage, setCurrentPage] = useState(1);
    const { isLoading, careDailyMedsList, selectedRpmPatient } = useSelector((state) => state.rpm);
    const dispatch = useDispatch();

    useEffect(() => {
        const payload = {
            patientCode: selectedRpmPatient.patientId,
            status: 1
        }
        dispatch(fetchRpmCPDailyMedicationList(payload));
    }, []);

    useEffect(() => {
        if (!selectedRpmPatient) {
            const rpmPatientJson = sessionStorage.getItem('rpmPatient');
            const rpmPatientObject = rpmPatientJson ? JSON.parse(rpmPatientJson) : null;
            if (rpmPatientObject) dispatch(setSelectedRpmPatient(rpmPatientObject));
        }
    }, []);


    return (
        <div>
            {
                isLoading && careDailyMedsList?.length === 0 ? (
                    <div className="flex items-center justify-center mt-[10%]">
                        <Flex align="center" gap="middle">
                            <Spin size="large" tip="Loading" />
                        </Flex>
                    </div>
                ) :
                    // careDailyTasksList?.length === 0 ?
                    //     (<div className="flex flex-col items-center justify-center">
                    //         <img src={nodatafound} alt="nodatafound" className="h-20 w-20" />
                    //         <p className="font-medium">No data found!!</p>
                    //     </div>
                    //     )
                    //     :
                    (
                        <div>
                            <CarePlanDailyMedicationTable
                                data={careDailyMedsList}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                totalCount={careDailyMedsList?.length}
                            />
                        </div>
                    )
            }
        </div>
    )
}

export default Index;